const ROOT = 'StepThree/publicationConfirmation/summary';

export const FETCH_SUMMARY_REQUEST = `${ROOT}/FETCH_SUMMARY_REQUEST`;
export const FETCH_SUMMARY_SUCCESS = `${ROOT}/FETCH_SUMMARY_SUCCESS`;
export const FETCH_SUMMARY_FAILURE = `${ROOT}/FETCH_SUMMARY_FAILURE`;
